module.exports = __webpack_public_path__ + "static/media/3.8a97bd1a.mp3";